import React, { useEffect, useMemo } from "react";
import { Formik, Form } from "formik";
import CustomInput from "components/CustomInput";
import { useQuery } from "@tanstack/react-query";
import { getAilmentGroupQuestion } from "services/getApis";
import { ErrorHandler } from "utils/toast";
import { Spinner } from "react-bootstrap";

const GeneralHealth = ({ onContinue = () => {}, ailmentId }) => {
  const { data, isError, error, isLoading, isFetching } = useQuery({
    queryKey: ["symptom_review", ailmentId],
    queryFn: () =>
      getAilmentGroupQuestion({
        group: "general_health",
        id: ailmentId,
      }),
    retry: 3,
  });

  const allHealthQuestions = useMemo(() => data?.payload || [], [data]);

  useEffect(() => {
    if (isError) {
      ErrorHandler(error);
    }
  }, [error, isError]);

  const initialValues = allHealthQuestions.reduce((acc, q) => {
    if (q.type === "boolean") {
      acc[q.id] = null;
    } else {
      acc[q.id] = "";
    }
    return acc;
  }, {});

  const handleSubmit = (values) => {
    console.log("Form submitted:", values);
    onContinue?.(values);
  };

  return (
    <>
      <h2 className="question-title">Your General Health Details</h2>

      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values }) => {
          const valuesArray = Object.values(values);
          const isAllFilled =
            valuesArray.length > 0 &&
            valuesArray.every(
              (val) => val !== null && val !== "" && val !== undefined
            );

          return (
            <Form className="form-section">
              {isLoading && isFetching ? (
                <div className="d-flex  justify-content-center  my-3">
                  <Spinner animation="border" />
                </div>
              ) : (
                <>
                  {allHealthQuestions.map((q) => (
                    <CustomInput
                      key={q.id}
                      name={q.id}
                      label={q.question}
                      placeholder={q.placeholder || ""}
                      type={q.type}
                      options={q.type === "dropdown" ? q.options : []}
                    />
                  ))}

                  <button
                    type="submit"
                    className={`continue-btn ${
                      isAllFilled ? "active" : "disabled"
                    }`}
                    disabled={!isAllFilled}
                  >
                    Continue
                  </button>
                </>
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default GeneralHealth;
